export const blockIconsFileNewspaper = (
	<span className='material-symbols-outlined'>newspaper</span>
);
